import React, { createContext } from 'react';
import { useSelector } from 'react-redux';
import { useCurrentConnector } from '../hooks/useCurrentConnector';

interface DataValidationV2ProviderProps {
  children: React.ReactNode;
}

// Define types that match the previous GraphQL types as closely as possible
// for minimal disruption to consuming components
export type RuleLibraryItem = NonNullable<
  ReturnType<typeof useCurrentConnector>['validationRulesLibrary']
>[number];

interface DataValidationV2ContextProps {
  validationRulesLibrary: RuleLibraryItem[];
  validationCustomRulesList: ReturnType<
    typeof useCurrentConnector
  >['validationCustomRulesList'];
  owner: string;
  connectorComponentModelName: string;
  validationContainers: ReturnType<
    typeof useCurrentConnector
  >['validationContainers'];
}

const DataValidationV2Context = createContext<DataValidationV2ContextProps>({
  validationRulesLibrary: [],
  validationCustomRulesList: [],
  owner: '',
  connectorComponentModelName: '',
  validationContainers: [],
});

export const DataValidationV2Provider = ({
  children,
}: DataValidationV2ProviderProps) => {
  const { domOwner: owner } = useSelector(
    (state: any) => state.user.profile.value
  );

  const {
    validationContainers,
    validationCustomRulesList,
    connectorComponentModelName,
    validationRulesLibrary,
  } = useCurrentConnector();

  return (
    <DataValidationV2Context.Provider
      value={{
        owner,
        validationRulesLibrary: (validationRulesLibrary || []) as any,
        validationCustomRulesList,
        connectorComponentModelName,
        validationContainers,
      }}
    >
      {children}
    </DataValidationV2Context.Provider>
  );
};

export const useDataValidationV2 = () => {
  const context = React.useContext(DataValidationV2Context);

  if (context === undefined) {
    throw new Error(
      'useDataValidationV2 must be used within a DataValidationV2Provider'
    );
  }

  return context;
};
